import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  snapDraftDialog,
  snapDraftDialogLastCount,
  unSnapDraftDialog,
  unSnapDraftDialogLastCount,
} from "store/bailiff/task/dialog/draft_dialog.action";
import {
  countTaskEffortIndice,
  sumTaskEffortIndice,
} from "store/bailiff/task/effort/task_effort.action";
import { getUnfinishedTask } from "store/bailiff/task/task_count/task_count.action";

//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(snapDraftDialog());
    return () => dispatch(unSnapDraftDialog());
  }, [dispatch]);

  // trigger count task.
  useEffect(() => {
    dispatch(snapDraftDialogLastCount());
    return () => dispatch(unSnapDraftDialogLastCount());
  }, [dispatch]);

  // trigger statistic.
  useEffect(() => {
    dispatch(countTaskEffortIndice());
    dispatch(sumTaskEffortIndice());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getUnfinishedTask());
  }, [dispatch]);

  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
